
import { Vue, Component } from "vue-property-decorator";

@Component({
    name: "Footer",
})
export default class DataViewer extends Vue {

}
